import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  const colorMap: Record<string, string> = {
    accent: 'bg-accent-100/80 text-accent-700 hover:bg-accent-200/80',
    primary: 'bg-primary-100/80 text-primary-700 hover:bg-primary-200/80',
    secondary: 'bg-secondary-100/80 text-secondary-700 hover:bg-secondary-200/80',
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            影迷圈里最火的话题，加入讨论一起聊
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className={`group px-4 py-2.5 md:px-5 md:py-3 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${colorMap[topic.color] || colorMap.primary}`}
            >
              <span>{topic.name}</span>
              <span className="ml-2 text-xs opacity-70">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}